import Card from 'react-bootstrap/Card'
import React, { useRef } from 'react'
import { Field } from 'formik'
import { Col, Row } from 'react-bootstrap'

import { InputDateComponent, InputTextComponent } from 'recupero-comunes'

import TableRecordLiquidation from './TableRecordLiquidation'
import Select from '../../../utils/select'
import NumberFormat from 'react-number-format'

const ParcialLoss = ({
  data,
  values,
  setFieldValue,
  form,
  errors,
  touched
}) => {
  const mPago = useRef(null)
  const mProvision = useRef(null)
  const mIndeniza = useRef(null)
  const mSituacion = useRef(null)

  const options = {
    form,
    data: data?.liquidation?.detalles
  }

  return (
    <Card.Body>
      <Card.Header
        className='border border-2'
        style={{backgroundColor: '#4F517A', color: 'white'}}
      >
        {form['antecliquidapp-title-seccion']}
      </Card.Header>

      {/* -------------------- Monto Pago--- */}
      <Row className='mt-2'>
        <Col md='2'>
          {data?.cbCoin?.length > 0 ? (
            <Select
              ref={mPago}
              name='mdaPago'
              label={form['antecliquidapp-cmb-mdapago']}
              defaultInputValue={
                data.cbCoin.find(
                  (item) => item.id === data?.liquidation?.codMonedaPago
                )?.nombre
              }
              labelKey='nombre'
              options={data.cbCoin ? data.cbCoin : []}
            />
          ) : null}
        </Col>

        <Col md='2' style={{fontWeight: 'bold', fontSize: '14px'}}>
          {form['antecliquidapp-input-mtopago']}
          <NumberFormat
            className='form-control mt-2'
            name='mtoPago'
            value={values.mtoPago}
            thousandSeparator='.'
            decimalScale={2}
            decimalSeparator={values.mdaPago === 30001 ? null : ','}
            onValueChange={(e) => {
              setFieldValue('mtoPago', e.floatValue, true)
            }}
          />
          {errors?.mtoPago ? (
            <div className='text-danger'>{errors?.mtoPago}</div>
          ) : null}
        </Col>
        <Col md='3' style={{fontWeight: 'bold', fontSize: '14px'}}>
          <InputDateComponent
            name='fechaPago'
            label={form['antecliquidapt-input-fechapago']}
          />
        </Col>

        <Col md='3'>
          {data?.cbPaymentSituaction?.length > 0 ? (
            <Select
              ref={mSituacion}
              name='situacionPago'
              label={form['antecliquidapp-cmb-sitpago']}
              defaultInputValue={
                data.cbPaymentSituaction.find(
                  (item) => item.id === data?.liquidation?.codSituacionPago
                )?.nombre
              }
              labelKey='nombre'
              options={data.cbPaymentSituaction ? data.cbPaymentSituaction : []}
            />
          ) : null}
        </Col>

        <Col md='2' style={{fontWeight: 'bold', fontSize: '14px'}}>
          <InputTextComponent
            name='factura'
            label={form['antecliquidapp-input-cntpagos']}
            value={data?.liquidation?.cntPagos}
            disabled
          />
        </Col>
      </Row>
      <Row className='mt-2'>
        {/* -------------------- Monto Indenizacion--- */}
        <Col md='2'>
          {data?.cbCoin?.length > 0 ? (
            <Select
              ref={mIndeniza}
              name='mdaIndemniza'
              label={form['antecliquidapt-cmb-mdaindemniza']}
              defaultInputValue={
                data.cbCoin.find(
                  (item) => item.id === data?.liquidation?.codMonedaIndeminza
                )?.nombre
              }
              labelKey='nombre'
              options={data.cbCoin ? data.cbCoin : []}
            />
          ) : null}
        </Col>
        <Col md='2' style={{fontWeight: 'bold', fontSize: '14px'}}>
          {form['antecliquidapt-input-mtoindemniza']}
          <NumberFormat
            className='form-control mt-2'
            name='mtoIndemnizacion'
            value={values.mtoIndemnizacion}
            thousandSeparator='.'
            decimalScale={2}
            decimalSeparator={values.mdaIndemniza === 30001 ? null : ','}
            onValueChange={(e) => {
              setFieldValue('mtoIndemnizacion', e.floatValue, true)
            }}
          />
          {errors?.mtoIndemnizacion ? (
            <div className='text-danger'>{errors?.mtoIndemnizacion}</div>
          ) : null}
        </Col>

        <Col md='3'>
          <Row className='mt-3'>
            <Col md='1'>
              <Field
                className=' mt-4 '
                type='checkbox'
                style={{
                  width: '25px',
                  height: '25px'
                }}
                name='indInformeLiquida'
              />
            </Col>
            <Col
              className='mt-4'
              style={{
                marginLeft: '8px'
              }}
              md='10'
            >
              {form['antecliquidadef-chk-liqasegurado-infliquida']}
            </Col>
          </Row>
        </Col>

        <Col md='3' className='mt-1' style={{fontWeight: 'bold', fontSize: '14px'}}>
          <InputDateComponent
            name='fechaInforme'
            value={data?.liquidation?.fechaPagoFormat}
            label={form['antecliquidadef-input-fechainforme']}
          />
        </Col>

        <Col md='2' style={{fontWeight: 'bold', fontSize: '14px'}}>
          <InputTextComponent
            name='factura'
            label={form['antecliquidapp-input-factcargadas']}
            value={data?.liquidation?.cntFacturas}
            disabled
          />
        </Col>
      </Row>

      {/* -------------------- Monto Provision--- */}
      <Row className='mt-2'>
        <Col md='2'>
          {data?.cbCoin?.length > 0 ? (
            <Select
              ref={mProvision}
              name='mdaProvision'
              label={form['antecliquidapt-cmb-mdaprovision']}
              defaultInputValue={
                data.cbCoin.find(
                  (item) => item.id === data?.liquidation?.codMonedaProvision
                )?.nombre
              }
              labelKey='nombre'
              options={data.cbCoin ? data.cbCoin : []}
            />
          ) : null}
        </Col>
        <Col md='2' style={{fontWeight: 'bold', fontSize: '14px'}}>
          {form['antecliquidapt-input-mtoprovision']}
          <NumberFormat
            className='form-control mt-2'
            name='mtoProvision'
            thousandSeparator='.'
            decimalScale={2}
            value={values.mtoProvision}
            decimalSeparator={values.mdaProvision === 30001 ? null : ','}
            onValueChange={(e) => {
              setFieldValue('mtoProvision', e.floatValue, true)
            }}
          />
          {errors?.mtoProvision ? (
            <div className='text-danger'>{errors?.mtoProvision}</div>
          ) : null}
        </Col>
      </Row>

      <TableRecordLiquidation {...options} />
    </Card.Body>
  )
}

export default ParcialLoss
